import {EmployeeStateConstant, MemberStateConstant} from '../constants';
import EcCommon from '../../../types/ec/ecCommon';
import EcMemberSearch from '../../../types/ec/ecMemberSearch';
import LtFramework from '../../../types/lt/ltFramework';

export const AlertNotificationState: LtFramework.IAlertNotificationState = {
	alertNotifications: new Array<LtFramework.IAlertNotification>(),
};

export const ClubLocationsState: EcCommon.IClubLocationsState = {
	countries: [],
	selectedClubs: [],
};

export const EmployeeProfileState: LtFramework.IEmployeeProfileState = {
	employeeProfile: {
		employeeState: EmployeeStateConstant.unknown,
		initialized: false,
	} as LtFramework.IEmployeeProfile,
};

export const MemberSearchState: EcMemberSearch.IState = {
	members: [],
};

export const ProfileState: LtFramework.IProfileState = {
	profile: {
		memberState: MemberStateConstant.unknown,
		initialized: false,
	} as LtFramework.IProfile,
};

export const UrlState: LtFramework.IUrlState = {
	url: {
		initialized: false,
	} as LtFramework.IUrl,
};
